module.exports = __webpack_public_path__ + "img/Indonesia-2.c18e6028.jpg";